module.exports = __webpack_public_path__ + "static/media/people-fill.fad3623e.svg";